/* eslint-disable @typescript-eslint/no-explicit-any */
import { ReactNode } from 'react';

type ShowProps = {
    when: boolean | string;
    children: ReactNode | ((props: any) => ReactNode);
    [key: string]: any;
};

export default function Show({ when, children, ...props }: ShowProps) {
    if (!when) {
        return null;
    }

    if (typeof children === 'function') {
        return <>{(children as (props: any) => ReactNode)(props)}</>;
    }

    return <>{children}</>;
}
